import PropTypes from 'prop-types';
import React from 'react';

import { createBEM } from '../../../../lib/utils/css';

import './RowItemNumber.scss';

const RowItemNumber = React.memo(({ rowNumber, isInteractive, isFullRowLink, useDarkTheme }) => {
  if (!isInteractive || isFullRowLink) {
    const classNames = createBEM('RowItemNumber', {
      dark: useDarkTheme,
    });

    return <div className={classNames}>{rowNumber}</div>;
  }

  return null;
});

RowItemNumber.propTypes = {
  rowNumber: PropTypes.number.isRequired,
  isInteractive: PropTypes.bool.isRequired,
  isFullRowLink: PropTypes.bool.isRequired,
  useDarkTheme: PropTypes.bool.isRequired,
};

export default RowItemNumber;
